import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Grid, Typography } from "@mui/material";
import "./Newhome.css";
import { useLanguage } from "../../../utils/languageContext";
import { Link } from "react-router-dom";

const logos = [
  "/images/National-health-mission.svg",
  "/images/NHP-India.svg",
  "/images/NHSRCfooter.svg",
  "/images/my-gov.svg",
  "/images/National-health-mission.svg",
  "/images/NHP-India.svg",
  "/images/NHSRCfooter.svg",
  "/images/my-gov.svg",
  "/images/National-health-mission.svg",
  "/images/NHP-India.svg",
  "/images/NHSRCfooter.svg",
  "/images/my-gov.svg",
];

const Newhomefooter = () => {
  const { t } = useLanguage();

  const [visitor, setVisitors] = useState(0);

  useEffect(() => {
    try {
      getVisitorCount();
    } catch (error) {
      console.error("Error in getting visitor count:", error);
    }
  }, []);

  const getVisitorCount = async () => {
    try {
      const response = await axios.get(`/nodeapi/aggregator/get-visitors`);
      setVisitors(response.data.totalVisitors);
    } catch (error) {
      console.log('Error in getting visitor count');
    }
  };

  return (
    <>
      {/* 🔷 LOGO CAROUSEL */}
      <div className="newhomefooter-logo-slider">
        <div className="newhomefooter-logo-track">
          {[...logos, ...logos].map((logo, i) => (
            <div className="newhomefooter-logo-item" key={i}>
              <img src={logo} alt="logo" />
            </div>
          ))}
        </div>
      </div>

      <Box className="newhomefooter-footer">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography className="newhomefooter-title">
              {t("homepage.footer.aboutTitle")}
            </Typography>
            <Typography className="newhomefooter-text">
              {t("homepage.footer.aboutText")}
            </Typography>
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography className="newhomefooter-title">
              {t("homepage.footer.quickLinks")}
            </Typography>
            <Typography className="newhomefooter-link" component="a" href="https://abdm.gov.in/" target="_blank" rel="noopener noreferrer">ABDM</Typography>
            <Typography className="newhomefooter-link" component="a" href="https://ncd.mohfw.gov.in/" target="_blank" rel="noopener noreferrer">NCD</Typography>
            <Typography className="newhomefooter-link" component="a" href="https://rch.mohfw.gov.in/RCH/" target="_blank" rel="noopener noreferrer">JANANI</Typography>
            <Typography className="newhomefooter-link" component="a" href="https://uwin.mohfw.gov.in/home" target="_blank" rel="noopener noreferrer">UWIN</Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography className="newhomefooter-title">
              {t("homepage.footer.quickLinks")}
            </Typography>
            <Typography className="newhomefooter-link" component="a" href="https://nikshay.in/" target="_blank" rel="noopener noreferrer">ni-Kshay</Typography>
            <Typography className="newhomefooter-link" component="a" href="https://pmndp.mohfw.gov.in/en" target="_blank" rel="noopener noreferrer">PMNDP</Typography>
            <Typography className="newhomefooter-link" component="a" href="https://sickle.nhm.gov.in/" target="_blank" rel="noopener noreferrer">SCD</Typography>
            <Typography className="newhomefooter-link" component={Link} to="/Privacy-policy">Privacy Policies</Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography className="newhomefooter-title">
              {t("homepage.footer.contactTitle")}
            </Typography>

            <div className="newhomefooter-contact">
              <span><img src="/images/Location.png" alt="Location" /></span>
              <span>{t("homepage.footer.address")}</span>
            </div>

            <div className="newhomefooter-contact">
              <span><img src="/images/Contact.png" alt="Contact" /></span>
              <span>{t("homepage.footer.phone")}</span>
            </div>

            <div className="newhomefooter-contact">
              <span><img src="/images/Mailicon.png" alt="Email" /></span>
              <span>{t("homepage.footer.email")}</span>
            </div>
          </Grid>
        </Grid>
      </Box>

      {/* 🔥 FIXED BOTTOM BAR */}
      <div className="newhomefooter-bottom">
        <Box className="visitor-card">
          <div className="visitor-left">
            <img src="/images/visitor-icon.png" alt="visitors" />
          </div>
          <div className="visitor-right">
            <Typography className="visitor-label">
              {t("homepage.footer.totalVisitors")}
            </Typography>
            <Typography className="visitor-count">{visitor}</Typography>
          </div>
        </Box>
        <div className="newhomefooter-bottom-content">
          {t("homepage.footer.copyright")}
          <span className="desktop-br">
            <br />
            {t("homepage.footer.totalVisitors")} - <strong> {visitor}</strong>
          </span>
        </div>
      </div>
    </>
  );
};

export default Newhomefooter;
